import React from 'react';


const WhatQuizElephant = ({
  alt = '',
  className = '',
  size = 64,
}) => (
  <img
    alt={alt}
    aria-hidden={alt ? undefined : true}
    className={`whatquiz-elephant ${className}`.trim()}
    draggable="false"
    height={size}
    src="/images/whatquiz-character.png"
    style={{
      display: 'block',
      height: size,
      objectFit: 'contain',
      width: size,
    }}
    width={size}
  />
);


export default WhatQuizElephant;
